import $ from 'jquery';
// eslint-disable-next-line no-unused-vars
import ajaxLoader from 'slick-carousel/slick/ajax-loader.gif';
require( './../../components/SlickAccessible/slick' );

$( function() {
	const $sliderWraps = $( '.slider-wrap' );
	const $slides = $sliderWraps.find( '.wp-block-prj-pt-gutenberg-blocks-slide' );

	// remove disabled slides
	$slides.each( function() {
		if ( '1' === $( this ).attr( 'data-disabled' ) ) {
			$( this ).remove();
		}
	} );

	// emit custom event we can attach to
	$sliderWraps.on( 'init', ( e, slick )=> {
		const event = new CustomEvent( 'dlr-pt-slider-init', { detail: { slick } } );
		document.dispatchEvent( event );
	} );

	// init sliders
	$sliderWraps.each( ( index, element ) => {
		// extract settings from slider wrap
		const $sliderWrap = $( element );
		const slickSettings = $sliderWrap.data( 'slick' ) || {};

		// add accessibility settings
		slickSettings.prevArrow = '<button type="button" aria-label="Vorheriges Element" class="slick-prev">Vorheriges Element</button>';
		slickSettings.nextArrow = '<button type="button" aria-label="Nächstes Element" class="slick-next">Nächstes Element</button>';

		// add fix for android ignoring our slick breakpoints
		if ( window?.screen?.width < 960 ) {
			slickSettings.slidesToShow = slickSettings?.slidesToShow > 2 ? 2 : slickSettings.slidesToShow;
			slickSettings.slidesToScroll = slickSettings?.slidesToScroll > 2 ? 2 : slickSettings.slidesToScroll;
		}
		if ( window?.screen?.width < 540 ) {
			slickSettings.slidesToShow = 1;
			slickSettings.slidesToScroll = 1;
		}

		// init slider
		$sliderWrap.slick( slickSettings );
	} );

	const svgPlay = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><rect x="0" fill="none" width="20" height="20"/><g><path d="M5 4l10 6-10 6V4z"/></g></svg>';
	const svgPause = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><rect x="0" fill="none" width="20" height="20"/><g><path d="M5 16V4h3v12H5zm7-12h3v12h-3V4z"/></g></svg>';

	// add play/pause buttons to slick dots
	$sliderWraps.each( function( index, element ) {
		const slickData = $( element ).data( 'slick' );
		if ( slickData.hasOwnProperty( 'autoplay' ) && slickData.autoplay ) {
			$( element ).find( '.slick-dots ' ).append(
				'<li role="presentation" class="slick-play-pause-wrap"><button class="slick-play-pause is-playing" aria-label="Slider pausieren">' + svgPause + '</button></li>'
			);
		}
	} );

	// event handler for play/pause
	$( '.slick-play-pause' ).on( 'click keydown', function( e ) {
		// only react to enter (space is handled by default in modern browsers)
		if ( 'keydown' === e.type && 13 !== e.which ) {
			return;
		}
		//stop slick slider event reaction (it emits another mouseclick on keydown)
		e.preventDefault();

		// toggle button status and aria-label
		const $control = $( this );
		if ( $control.hasClass( 'is-playing' ) ) {
			$control.closest( '.slider-wrap' ).slick( 'slickPause' );
			$control.removeClass( 'is-playing' );
			$control.attr( 'aria-label', 'Slider starten' );
			$control.html( svgPlay );
		} else {
			$control.closest( '.slider-wrap' ).slick( 'slickPlay' );
			$control.addClass( 'is-playing' );
			$control.attr( 'aria-label', 'Slider pausieren' );
			$control.html( svgPause );
		}
	} );
} );

export default () => {};
